exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.keyword[data-v-dc736bf2]{position:relative}.clear-keyword[data-v-dc736bf2]{position:absolute;top:2px;right:35px;z-index:9}.list-unstyled li[data-v-dc736bf2]{font-weight:300}.list-unstyled li h5[data-v-dc736bf2]{line-height:1.4}.py-2px[data-v-dc736bf2]{padding-top:2px;padding-bottom:2px}#search-autocomplete-sdc-small a.dropdown-item[data-v-dc736bf2],#search-autocomplete-sdc-small a.dropdown-item.active[data-v-dc736bf2],#search-autocomplete-sdc-small a.dropdown-item.active[data-v-dc736bf2]:hover{color:#16181b!important}", ""]);

// exports
